import { applyPlanAlignmentToPoint } from "utils/math/applyPlanAlignmentToPoint";
import {
  GetDirectionArrowPoints,
  BuildMiniMapPlanPoints,
  MiniMapPlanPoints,
} from "./types";

export const getDirectionArrowPoints: GetDirectionArrowPoints = ({
  from,
  to,
  arrowSize = 3,
  minSegmentLength = 5,
  positionRatio = 0.7,
}) => {
  const deltaX = to.x - from.x;
  const deltaY = to.y - from.y;

  const segmentLength = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

  if (segmentLength < minSegmentLength) return null;

  // Unit direction vector
  const directionX = deltaX / segmentLength;
  const directionY = deltaY / segmentLength;

  // Arrow tip position along the segment
  const arrowTipX = from.x + deltaX * positionRatio;
  const arrowTipY = from.y + deltaY * positionRatio;

  // Arrow head wing points
  const leftWingX =
    arrowTipX - arrowSize * directionX - arrowSize * directionY * 0.5;

  const leftWingY =
    arrowTipY - arrowSize * directionY + arrowSize * directionX * 0.5;

  const rightWingX =
    arrowTipX - arrowSize * directionX + arrowSize * directionY * 0.5;

  const rightWingY =
    arrowTipY - arrowSize * directionY - arrowSize * directionX * 0.5;

  return `${arrowTipX},${arrowTipY} ${leftWingX},${leftWingY} ${rightWingX},${rightWingY}`;
};

export const buildMiniMapPlanPoints: BuildMiniMapPlanPoints = ({
  cameraFrames,
  floorPlanAlignment,
}) => {
  const miniMapPlanPoints = cameraFrames.reduce<MiniMapPlanPoints>(
    (acc, cameraFrame) => {
      const { x, y } = applyPlanAlignmentToPoint({
        point: {
          x: cameraFrame.processedPosition[0],
          y: cameraFrame.processedPosition[1],
        },
        planAlignment: floorPlanAlignment,
      });

      acc.planPoints.push({
        x,
        y,
        frameName: cameraFrame.frameName,
      });

      acc.pathLinePoints += `${x},${y} `;

      if (acc.prev) {
        const arrow = getDirectionArrowPoints({
          from: acc.prev,
          to: { x, y },
        });

        if (arrow) acc.arrowPoints.push(arrow);
      }

      acc.prev = { x, y };
      return acc;
    },
    {
      planPoints: [],
      pathLinePoints: "",
      arrowPoints: [],
      prev: null,
    },
  );

  return miniMapPlanPoints;
};
